import { Component } from '@angular/core';

@Component({
    selector: 'app-card-section',
    standalone: true,
    imports: [],
    templateUrl: './card-section.component.html',
    styles: ``,
})
export class CardSectionComponent {}
